// extracted by mini-css-extract-plugin
export default {"edubWrapper":"index_edubWrapper__eChqx","boardWrapper":"index_boardWrapper__Rw1-i"};